import { CombinedGraphQLErrors, ServerError, ServerParseError } from '@apollo/client';
import { classifyGraphQLErrorExtensions, classifyHttpStatus, SessionErrorKind } from '@repo/common';
export function classifyApolloSessionError(error) {
    if (CombinedGraphQLErrors.is(error)) {
        for (const gqlError of error.errors) {
            if (!gqlError || typeof gqlError !== 'object') {
                continue;
            }
            const extensions = gqlError.extensions;
            const kind = classifyGraphQLErrorExtensions(extensions);
            if (kind !== SessionErrorKind.Unknown) {
                return kind;
            }
        }
        return SessionErrorKind.Unknown;
    }
    if (ServerError.is(error)) {
        return classifyHttpStatus(error.statusCode, error.bodyText);
    }
    if (ServerParseError.is(error)) {
        return SessionErrorKind.Transient;
    }
    if (error instanceof TypeError) {
        return SessionErrorKind.Transient;
    }
    return SessionErrorKind.Unknown;
}
export function isNetworkOrServerSessionError(error) {
    const kind = classifyApolloSessionError(error);
    return kind === SessionErrorKind.Transient;
}
//# sourceMappingURL=classify-apollo-session-error.js.map